import { Box } from "@mui/material";

export function HeroImageSection() {
  return (
    <Box
      sx={{
        display: "flex",
        flex: "auto",
        flexDirection: "column",
        width: "100vw",
        position: "relative",
        height: "400px",
        overflow: "hidden"
      }}
    >
      <Box
        component="img"
        src="/images/banners/top-kv01_re2.jpg"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          filter: "blur(6px)"
        }}
      />
    </Box>
  );
}
